import { createReducer, on } from '@ngrx/store';
import { setIsDialogOpeningAction } from 'app/store/global/dialog/dialog.action';
import { dialogState } from './dialog.state';

const dialogReducer = createReducer(
  dialogState,
  on(setIsDialogOpeningAction, (state, action) => {
    return {
      ...state,
      isOpening: action.payload,
    };
  })
);

export default dialogReducer;
